module.exports = __webpack_public_path__ + "static/media/government.49bd2309.svg";